<template>
  <div class="authorities-form">
   <FunctionTitle :title="title" />
    <CommonFlame :title="title" >
      <v-container>
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row align="center" justify="center">
            <v-col
              cols="12"
              sm="8"
              md="6"
            >
              <v-text-field
                label="権限名"
                v-model="name"
                required
                :rules="[rules.requiredValue]"
                class="my-10"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <h3>機能の設定</h3>
          <div class="table-container mt-4">
            <v-data-table
              locale="ja-JP"
              :headers="headers"
              :items="features"
              :mobile-breakpoint="240"
              hide-default-footer
              disable-filtering
              disable-pagination
              disable-sort
              no-data-text="データがありません。"
            >
            <template v-slot:item="{ item }">
              <tr> 
                <td>
                  <v-checkbox 
                  :rules="[rules.required]"
                  required
                  hide-details="auto"
                  :value="item.id"
                  v-model="authority_features"
                  multiple
                  >
                  </v-checkbox>
                </td>
                <td>{{ item.name}}</td>
                <td>{{ item.description}}</td>
              </tr>
            </template>
            </v-data-table>
          </div>
          <v-row no-gutters class="my-4" justify="center">
            <v-btn color="secondary" @click="updateAuthority()" :dark="isValid" :disabled="!isValid">
              <v-icon>mdi-plus</v-icon>
              登録する
            </v-btn>
				  </v-row>
        </v-form>
      </v-container>
    </CommonFlame>
  </div>
</template>

<script>
  import axios from 'axios';
  import rules from "../../helper/rules";
  import errorHandling from "../../helper/errorHandling";
  import authenticate from "../../helper/authenticate";
  import FunctionTitle from "../shared/FunctionTitle.vue"
  import CommonFlame from "../shared/CommonFlame.vue"

  export default {
     components: {
      FunctionTitle,
      CommonFlame,
	  },
    data() {
      return {
        edit_id: this.$route.params["id"],
        name: "",
        rules: rules,
        valid: false,
        features: [],
        feature_names:[],
        authority_features:[],
        title:"権限編集",
        headers: [
          { text: "チェック",value: "", width:"100px"},
          { text: "機能名", value: "name", width:"250px" },
          { text: "機能説明", value: "description", width:"400px"},
			  ],
      }
    },

    mounted(){
      authenticate.authenticateUser();
      const headers = authenticate.setHeader();
      const edit_id = this.$route.params["id"]
      axios
        .get(`/erp/v1/authorities/${this.edit_id}/edit`, { headers, params:{edit_id}})
        .then((res) => {
          this.feature_names = res.data.authority.features
          this.authority_features = res.data.authority_features
          this.name = res.data.authority.name
          this.features = res.data.features
        })
        .catch((err) => {
          errorHandling.errorResponse(err);
        });
    },

    methods: {
      updateAuthority(){
        if (!this.$refs.form.validate()) return;
        const headers = authenticate.setHeader()
        const formData = new FormData()
        formData.append("authority[name]", this.name)
        this.authority_features.forEach((v) => {
          formData.append("authority[feature_ids]" + "[]", v);
        })
        axios
          .put(`/erp/v1/authorities/${this.edit_id}`, formData, { headers })
          .then((res) => {
            this.$store.commit("setFlash", {
              text: "更新しました",
              type: "notice",
            });
            this.$router.push({ name:"authority_index" })
          })
          .catch((err) => {
            errorHandling.errorResponse(err);
          })
        
      },
    },
    computed: {
      isValid() {
        return this.authority_features.length > 0 && this.name.length > 0
      }
    },
  }
</script>